import React from 'react';
import Button from '@mui/material/Button';
import { bool, func, number, string } from 'prop-types';
import {
  PTO_DIALOGUE_TYPES,
  PTO_STATUS,
} from 'feature/inventory-management/product-transfer-order/utils';
import { useUserRolePermissions } from 'hooks';

const ActionButtons = ({
  affiliateIsOriginator,
  onCopyPto,
  onEditPto,
  onViewDetails,
  ptoNumber,
  setCurrentPtoDialogueOpen,
  status,
}) => {
  const { isProductOwnerManage } = useUserRolePermissions();

  const openPtoDialog = type =>
    setCurrentPtoDialogueOpen({
      ptoDialogueType: type,
      ptoNumber,
    });

  const ApprovalNeededActions = () => (
    <>
      {isProductOwnerManage ? (
        <>
          <Button
            fullWidth
            onClick={() => openPtoDialog(PTO_DIALOGUE_TYPES.reject)}
            variant="outlined"
          >
            Reject
          </Button>
          <Button
            fullWidth
            onClick={() => openPtoDialog(PTO_DIALOGUE_TYPES.accept)}
            variant="contained"
          >
            Accept
          </Button>
        </>
      ) : (
        <Button onClick={onViewDetails} variant="contained">
          View
        </Button>
      )}
    </>
  );

  const PendingOrApprovedActions = () => (
    <>
      {affiliateIsOriginator && isProductOwnerManage ? (
        <>
          <Button
            fullWidth
            onClick={() => openPtoDialog(PTO_DIALOGUE_TYPES.cancel)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button fullWidth onClick={onCopyPto} variant="contained">
            Copy
          </Button>
        </>
      ) : (
        <Button onClick={onViewDetails} variant="contained">
          View
        </Button>
      )}
    </>
  );

  const RejectedActions = () =>
    affiliateIsOriginator ? (
      isProductOwnerManage ? (
        <>
          <Button
            fullWidth
            onClick={() => openPtoDialog(PTO_DIALOGUE_TYPES.cancel)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button fullWidth onClick={onEditPto} variant="contained">
            Edit
          </Button>
        </>
      ) : (
        <Button onClick={onViewDetails} variant="contained">
          View
        </Button>
      )
    ) : (
      <Button onClick={onViewDetails} variant="contained">
        View
      </Button>
    );

  return (
    <>
      {status === PTO_STATUS.approvalNeeded && <ApprovalNeededActions />}
      {status === PTO_STATUS.pendingApproval && <PendingOrApprovedActions />}
      {status === PTO_STATUS.approved && <PendingOrApprovedActions />}
      {status === PTO_STATUS.rejected && <RejectedActions />}
      {status === PTO_STATUS.scheduled && <PendingOrApprovedActions />}
    </>
  );
};

ActionButtons.propTypes = {
  affiliateIsOriginator: bool.isRequired,
  onCopyPto: func.isRequired,
  onEditPto: func.isRequired,
  onViewDetails: func.isRequired,
  ptoNumber: number.isRequired,
  setCurrentPtoDialogueOpen: func.isRequired,
  status: string.isRequired,
};

export default ActionButtons;
